import styled from 'styled-components'

// styles
import { screenReaderOnly } from '../../styles/helpers'

export const VisuallyHidden = styled.span`
	${screenReaderOnly};
`
